// extracted by mini-css-extract-plugin
export default {"image":"ProductCard_image__lbBJG","product":"ProductCard_product__hz3KA","button":"ProductCard_button__ppsX8"};